import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  searchResults,
  searchResultsSucess,
  searchWithFilters,
  searchWithLanguage,
  searchWithCity,
} from './explore.action';
import { catchError, map, mergeMap, of, switchMap, withLatestFrom } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { getFunctionsSuccess } from 'src/app/functions/store/functions.action';
import { UserService } from 'src/app/services/user.service';
import { ExploreService } from '../explore.service';
import { ExploreFacade } from './explopre.facade';

@Injectable()
export class ExploreEffects {
  // searchResults$ = createEffect(() =>
  //   this.actions$.pipe(
  //     ofType(searchResults),
  //     switchMap((action) =>
  //       this.exploreService
  //         .search(`v2/songs/search?include_terms[]=` + action.term + `&page=1`)
  //         .pipe(
  //           map((data: any) => {
  //             return searchResultsSucess({ searchResults: data });
  //           }),
  //           catchError((error: HttpErrorResponse) => {
  //             return of();
  //           }),
  //         ),
  //     ),
  //   ),
  // );

  searchWithFilters$ = createEffect(() =>
    this.actions$.pipe(
      ofType(searchWithFilters),
      withLatestFrom(
        this.exploreFacade.searchTerm$,
        this.exploreFacade.languages$,
        this.exploreFacade.timeframes$,
        this.exploreFacade.moods$,
        this.exploreFacade.location$,
        this.exploreFacade.include$,
        this.exploreFacade.exclude$,
        this.exploreFacade.city$,
        this.exploreFacade.selectedRhymes$
      ),
      switchMap(([action, searchTerm, language, timeframe, moods, location, include, exclude, city, selectedRhymes]) => {
        return this.exploreService
          .search(getUrl(searchTerm, language, timeframe, moods, location, include, exclude, city, selectedRhymes))
          .pipe(
            map((data: any) => {
              console.log(timeframe)
              console.log(location)
              return searchResultsSucess({ searchResults: data });
            }),
            catchError((error: HttpErrorResponse) => {
              return of();
            }),
          );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private exploreFacade: ExploreFacade,
    private exploreService: ExploreService,
  ) { }
}

function getUrl(searchTerm, language, timeframe, moods, location, include, exclude, city, selectedRhymes) {
  let url = `v2/songs/search?page=1`;

  if (searchTerm) {
    url += `&include_terms[]=` + searchTerm;
  }
  if (language) {
    url += `&lang=` + language;
  }
  console.log(location)
  if (location) {
    url += `&country=` + location;
  }

  if (city) {
    url += `&city=` + city;
  }
  if (include) {
    url += include.map(term => `&include_terms[]=${encodeURIComponent(term)}`).join('');
  }

  if (exclude) {
    url += exclude.map(term => `&exclude_terms[]=${encodeURIComponent(term)}`).join('');

  }

  if (timeframe) {
    console.log(timeframe.start_date)
    if (timeframe.start_date != '' && timeframe.start_date != '') {
      url +=
        `&start_date=` + timeframe.startDate + `&end_date=` + timeframe.endDate;
    }

  }

  if (moods) {
    Object.keys(moods).forEach((key) => {
      url +=
        `&` +
        moods[key].name +
        `[gte]=` +
        moods[key].range.value +
        `&` +
        moods[key].name +
        `[lte]=` +
        moods[key].range.highValue;
    });
  }

  if (selectedRhymes && selectedRhymes.length > 0) {
    selectedRhymes.forEach((rhyme) => {
      if (rhyme.name === 'syllablesPerWord') {
        url += `&syllables_per_word[gte]=${rhyme.range.value}&syllables_per_word[lte]=${rhyme.range.highValue}`;
      } else if (rhyme.name === 'rhymesPerLine') {
        url += `&rhymes_per_line[gte]=${rhyme.range.value}&rhymes_per_line[lte]=${rhyme.range.highValue}`;
      } else if (rhyme.name === 'lineInternalsPerLine') {
        url += `&line_internals_per_line[gte]=${rhyme.range.value}&line_internals_per_line[lte]=${rhyme.range.highValue}`;
      } else if (rhyme.name === 'doublesPerRhyme') {
        url += `&doubles_per_rhyme[gte]=${rhyme.range.value.toFixed(1)}&doubles_per_rhyme[lte]=${rhyme.range.highValue.toFixed(1)}`;
      } else if (rhyme.name === 'triplesPerRhyme') {
        url += `&triples_per_rhyme[gte]=${rhyme.range.value.toFixed(1)}&triples_per_rhyme[lte]=${rhyme.range.highValue.toFixed(1)}`;
      } else if (rhyme.name === 'quadsPerRhyme') {
        url += `&quads_per_rhyme[gte]=${rhyme.range.value.toFixed(1)}&quads_per_rhyme[lte]=${rhyme.range.highValue.toFixed(1)}`;
      } else if (rhyme.name === 'perfectRhymes') {
        url += `&perfect_rhymes[gte]=${rhyme.range.value}&perfect_rhymes[lte]=${rhyme.range.highValue}`;
      } else if (rhyme.name === 'rhymeDensity') {
        url += `&rhyme_density[gte]=${rhyme.range.value}&rhyme_density[lte]=${rhyme.range.highValue}`;
      } else if (rhyme.name === 'novelWordProportion') {
        url += `&novel_word_proportion[gte]=${rhyme.range.value}&novel_word_proportion[lte]=${rhyme.range.highValue}`;
      }
    });
  }
  url += '&xXx_enable_lyrical_content_xXx=true';

  return url;
}
